const useAuthUserToken = () => {
  const userToken = localStorage.getItem("user.token") || null
  return {userToken}
}

export default useAuthUserToken